import Reflux from 'reflux';

import SelfAssessmentAPI from '../api/SelfAssessment';

const SelfAssessmentActions = Reflux.createActions({
  save: {
    asyncResult: true,
  },
});

SelfAssessmentActions.save.listen(function (branchId, rating) {
  SelfAssessmentAPI.save(branchId, rating).then(
    function (result) {
      return this.completed((result || {}).body);
    }.bind(this)
  );
});

export default SelfAssessmentActions;
